import React from 'react'
import Head from 'next/head'
import TvTrianglePicker from '../../../components/common/TvTrianglePicker'
import { getPickerSeo } from '../../../utils/pickerSeo'

export default function BuyAnglePage () {
  const { title, description, url } = getPickerSeo('tv')
  return (
    <div className="tv-picker-page-container">
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
      </Head>
      <div className="product-picker product-picker--tv">
        <div className="product-picker-content no-max-width">
          <TvTrianglePicker />
        </div>
      </div>
    </div>
  )
}
